import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/shared/globals';
import { AuthService } from 'src/app/services/core/auth.services';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-expiration-message',
  standalone: false,
  templateUrl: './expiration-message.component.html',
  styleUrls: ['./expiration-message.component.scss']
})
export class ExpirationMessageComponent implements OnInit {
  showExpirationMessage = false;
  constructor(private globals: Globals, public auth: AuthService, public translate: TranslateService, public http: HttpClient) {}

  ngOnInit() {
    this.translate.use(localStorage.getItem('lang'));
    this.globals.sessionDialogStatus.subscribe(showStatus => {
      this.showExpirationMessage = showStatus;
    });
  }

  handleContinueSession() {
    this.globals.setSessionTimer();
    this.http.get(environment.getRoles).subscribe(() => {
      this.globals.setSessionTimer();
    });
  }

  handleStopSession() {
    this.globals.resetSessionIntervals();
    localStorage.setItem('close', new Date().getTime().toString());

    this.auth.logout();
  }
}
